// removed by extract-text-webpack-plugin
module.exports = {"container":"_21wIL3t","wrapper":"fDaZ3Z4","slideUp":"_2avUdZl","flag":"zTT_AGe","text":"BRd5uim","redirectLink":"_3Mus2JK","closeButton":"_2np3kDs"};


//////////////////
// WEBPACK FOOTER
// ./template/components/WelcomeMessage/index.css
// module id = ./template/components/WelcomeMessage/index.css
// module chunks = client.sitechrome